import * as Popper from '@popperjs/core';

const TOOLTIP_CLASSNAME = '.tooltip';
const TOOLTIP_INNER_CLASSNAME = '.tooltip-inner';

const show = (popperInstance: Popper.Instance, tooltip: Element) => {
  // Make the tooltip visible
  tooltip.setAttribute('data-show', '');

  // Enable the event listeners
  popperInstance.setOptions((options) => ({
    ...options,
    modifiers: [
      ...(options.modifiers as any),
      { name: 'eventListeners', enabled: true },
    ],
  }));

  // Update its position
  popperInstance.update();
};

const hide = (popperInstance: Popper.Instance, tooltipInnerEl: Element) => {
  // Hide the tooltip
  tooltipInnerEl.removeAttribute('data-show');

  // Disable the event listeners
  popperInstance.setOptions((options) => ({
    ...options,
    modifiers: [
      ...(options.modifiers as any),
      { name: 'eventListeners', enabled: false },
    ],
  }));
};

export const initTooltip = () => {
  const tooltipEls = document.querySelectorAll(TOOLTIP_CLASSNAME);

  const showEvents = ['mouseenter', 'focus'];
  const hideEvents = ['mouseleave', 'blur'];

  tooltipEls.forEach((tooltipEl) => {
    const tooltipInnerEl = tooltipEl.querySelector(TOOLTIP_INNER_CLASSNAME);

    if (!tooltipInnerEl) {
      return;
    }

    const popperInstance = Popper.createPopper(
      tooltipEl,
      tooltipInnerEl as HTMLElement,
      {
        placement: 'top',
        strategy: 'fixed',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ],
      }
    );

    showEvents.forEach((event) => {
      tooltipEl.addEventListener(event, () =>
        show(popperInstance, tooltipInnerEl)
      );
    });

    hideEvents.forEach((event) => {
      tooltipEl.addEventListener(event, () =>
        hide(popperInstance, tooltipInnerEl)
      );
    });
  });
};
